import React from "react";
import Modal from "react-modal";
import { connect } from "react-redux";
import { loadSession } from "../../redux/reducers/global-catalog.reducer";
import { cloneDeep } from "lodash";
import TextInput from "../controls/text-input";
import { RecommendationError } from "../../control/orders/consolidate-trip-modal";
import Tag from "../controls/tag";
import Button from "../controls/button";
import { getUrlsEnv } from "../backend-api";
import ImageWithCheckMark from "../component/image-with-check-mark";
import moment from 'moment';
import { cancelMultipleRequests, createEntity, readEntities } from "../../redux/api/actions";
import { getEntityItems } from "../../redux/api";
import Loader from "../icons/tat/loader";
import { sendMessageToMultipleUsersInSocket, showSimpleFlashNotification } from "../utils";

Modal.setAppElement("#root");

class ConvertOrdersToTripModal extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      mainOrder: cloneDeep(props.order),
      codeDuplicated: false,
      selectedTags: [],
      orders: [cloneDeep(props.order)],
      isConsolidateOrders: false,
      optionSelected: 1,
      selectedCode: '',
      inboundOrders: [], // compra
      outboundOrders: [], // venta
      ordersToAdd: [],
      errorMessage: null
    }
  }

  componentDidMount () {

  }

  onClose = () => {
    if (this.props.isLoading || this.props.isCreationLoading) return;
    if (this.props.closeAction) this.props.closeAction();
  }


  buildTitle = () => {

    if (this.state.isConsolidateOrders) {
      return(
        <>
          <div className="title-action">{'Consolidación de Órdenes'}</div>
          <div className="subtitle">{'Órdenes Disponibles para Consolidar Embarque'}</div>
        </>
      );
    } else {
      return(
        <>
          <div className="title-action">{'Convertir Orden en Embarque'}</div>
        </>
      );
    }
  }

  handleChange = (e) => {
    this.state.errorMessage = null;

    if (e.target.name === 'selectedCode') {
      this.setState({[e.target.name]: e.target.value.replace(/\s/g, '')})
      return;  
    }

    this.setState({[e.target.name]: e.target.value})
  }

  buildOrderInputs = () => {
    return(
      <>
        <div className="order-inputs-container" style={{width: '50%'}}>
          <div className="input-item" style={{width: '50%'}}>
            <TextInput
              label="Número de Embarque (Viaje)"
              name="selectedCode"
              value={this.state.selectedCode}
              className="item"
              onChange={this.handleChange}
              isUserTyping={() => {
                if (this.state.codeDuplicated) {
                  this.setState({codeDuplicated: false});
                }
              }}
              handleBlur={(e) => {
                this.props.validateCodeTrip({
                  company_id: this.props.companyId,
                  code: this.state.selectedCode
                }, {
                  onSuccess: (response) => {
                    this.setState({
                      codeDuplicated: 'exist' in response && response.exist
                    });
                  }
                });
              }}
            />
            {
              this.state.codeDuplicated === true &&
              <RecommendationError>
                {'El código ya está en uso'}
              </RecommendationError>
            }
          </div>
        </div>

        <div className="order-inputs-container">
          <div>
            <div style={{color: 'rgba(155, 161, 172, 0.7)', lineHeight: '18px', fontSize: 12}}>{'Selecciona las Etiquetas de tu Viaje (opcional)'}</div>
            <div className="input-tags" style={{height: 40, overflowY: 'auto'}}>
              {(this.props.tagsCatalog || []).map((tag) => {
                return (
                  <Tag
                    key={tag.id}
                    id={tag.id}
                    color={tag.color}
                    title={tag.title}
                    type={tag.type}
                    isFull={this.state.selectedTags.includes(tag.id)}
                    onClick={() => {
                      if (this.state.selectedTags.includes(tag.id)) {
                        this.state.selectedTags = this.state.selectedTags.filter( item => item !== tag.id)
                      } else {
                        this.state.selectedTags.push(tag.id);
                      }

                      this.state.errorMessage = null;

                      this.setState({});
                    }}
                    parentBackground="light"
                  />
                );
              })}
            </div>
          </div>
        </div>
      </>
    );
  }

  getOrigin = (order) => {
    let from_facility = order.from_facility;
    let from_facility_company = order.from_company;

    return(
      <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
        {
          from_facility_company ?
          <ImageWithCheckMark
            src={getUrlsEnv().files.concat(from_facility_company.logo?.substring(1) || '')}
            width={25}
            isCheckMark={from_facility_company.verification_status === 3}
            customStyle={{
              width: 25, height: 25, borderRadius: '50%', position: 'relative', marginRight: 8
            }}
            type={from_facility_company.type_id}
          /> : <div/>
        }

        <div>{`${from_facility.name}`}</div>
      </div>
    );
  }

  getDestiny = (order) => {
    let to_facility = order.to_facility;
    let to_facility_company = order.to_company;

    return(
      <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
        {
          to_facility_company ?
          <ImageWithCheckMark
            src={getUrlsEnv().files.concat(to_facility_company.logo?.substring(1) || '')}
            width={25}
            isCheckMark={to_facility_company.verification_status === 3}
            customStyle={{
              width: 25, height: 25, borderRadius: '50%', position: 'relative', marginRight: 8
            }}
            type={to_facility_company.type_id}
          /> : <div/>
        }

        <div>{`${to_facility.name}`}</div>
      </div>
    );
  }

  getAppointmentLoadingDate = (order) => {
    if (order.appointment_loading_date) {
      return(<div>{moment(order.appointment_loading_date).format('DD/MM/YYYY HH:mm')}</div>);
    } else {
      return(<div>{'-'}</div>);
    }
  }

  getAppointmentUnloadingDate = (order) => {
    if (order.appointment_unloading_date) {
      return(<div>{moment(order.appointment_unloading_date).format('DD/MM/YYYY HH:mm')}</div>);
    } else {
      return(<div>{'-'}</div>);
    }
  }

  buildOrders = () => {
    return(
      <div className="deliveries-content">
        <div className="title-deliveries-content">{'Órdenes en este Embarque'}</div> 

        <div className="delivery-row">
          <div className="delivery-item">{'Número de Orden'}</div>
          <div className="delivery-item">{'Origen'}</div>
          <div className="delivery-item">{'Destino'}</div>
          <div className="delivery-item">{'Cita de Carga'}</div>
          <div className="delivery-item">{'Cita de Descarga'}</div>
          <div className="delivery-item">{'Tipo'}</div>
          <div className="delivery-item">{'Mercancía Peligrosa'}</div>
          <div className="delivery-item">{'Clase de Expedición'}</div>
          <div className="delivery-item">{'Estatus de Orden'}</div>
          <div style={{width: 20}}></div>
        </div>

        <div className="delivery-list">
          {
            (this.state.orders || []).map( (order, index) => {

              let type = '';
              let transport_class = '';

              if (order.type === 'FTL') {
                type = `${order.type} - ${(order.container_ids || []).length > 1 ? 'Full' : 'Sencillo'}`;
              } else {
                type = order.type;
              }

              if ((this.props.company?.type?.id || 0) === 3) {

                let from_facility_company_type = order?.from_facility?.company?.type_id || 0;
                let to_facility_company_type = order?.to_facility?.company?.type_id || 0;

                if (from_facility_company_type === 3 && this.props.transactionType === 2) {
                  transport_class = order.transport_class_provider?.label || '';
                } else if (to_facility_company_type === 3 && this.props.transactionType === 1) { 
                  transport_class = order.transport_class_client?.label || '';
                }

              } else {

                if (this.props.companyId === (order.from_company?.id || 0)) {
                  transport_class = order.transport_class_provider?.label || '';
                } else {
                  transport_class = order.transport_class_client?.label || '';
                }

              }

              return(
                <div className="delivery-row with-hover" key={`delivery-row-${index}`}>
                  <div className="delivery-item">{`${order.order_code}`}</div>
                  <div className="delivery-item">{this.getOrigin(order)}</div>
                  <div className="delivery-item">{this.getDestiny(order)}</div>
                  <div className="delivery-item">{this.getAppointmentLoadingDate(order)}</div>
                  <div className="delivery-item">{this.getAppointmentUnloadingDate(order)}</div>
                  <div className="delivery-item">{type}</div> 
                  <div className="delivery-item">{order.has_dangerous_products ? 'Sí' : 'No'}</div>
                  <div className="delivery-item">{transport_class}</div>
                  <div className="delivery-item">{`${order.order_status?.description || ''}`}</div>
                  <div style={{width: 20, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <img
                      alt=""
                      src="/images/bin.png"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.setState({
                          orders: this.state.orders.filter( item => item.order_id !== order.order_id),
                          ordersToAdd: this.state.ordersToAdd.filter( item => item !== order.order_id)
                        })
                      }}
                    />
                  </div>
                </div>
              );
            })
          }
        </div>
      </div>
    );
  }

  buildAddMoreOrders = () => {

    let transport_type = '';

    switch (this.state.mainOrder.type) {
      case 'FTL':
        transport_type = 1;
        break;
      case 'LTL':
        transport_type = 2;
        break;
      case 'FCL':
        transport_type = 3;
        break;
      case 'LCL':
        transport_type = 4;
        break;
      case 'FFCC':
        transport_type = 5;
        break;
      case 'Aéreo':
        transport_type = 6;
        break;
      default:
        transport_type = '';
    }

    return(
      <div
        style={{color: '#3d77f7', cursor: 'pointer', display: 'flex', alignItems: 'center', marginTop: 35}}
        onClick={() => {
          this.setState({
            isConsolidateOrders: true,
            errorMessage: null
          });

          this.props.cancelMultipleRequests();

          let data = {
            company_id: this.props.companyId,
            order_id: this.state.mainOrder.order_id,
            consolidate: true,
            has_dangerous_products: this.state.mainOrder.has_dangerous_products,
            transaction_type: this.props.transactionType,
            isMultipleCancels: true,
            transport_type_id: transport_type
          };

          this.props.loadFacilityRequisitions(data, {
            onSuccess: (response) => {

              this.setState({
                inboundOrders: response.inbound,
                outboundOrders: response.outbound
              });

            },
            onError: (e) => {
              
            }
          })

        }}
      >
        <div className="add-icon">+</div>
        <div>
          {'Añadir Órdenes'}
        </div>
      </div>
    );
  }

  convertOrdersToTrip = () => {
    let transport_type = '';

    switch (this.state.mainOrder.type) {
      case 'FTL':
        transport_type = 1;
        break;
      case 'LTL':
        transport_type = 2;
        break;
      case 'FCL':
        transport_type = 3;
        break;
      case 'LCL':
        transport_type = 4;
        break;
      case 'FFCC':
        transport_type = 5;
        break;
      case 'Aéreo':
        transport_type = 6;
        break;
      default:
        transport_type = '';
    }

    let data = {
      company_id: this.props.companyId,
      action: 'order_to_trip',
      trip_code: this.state.selectedCode,
      tags: this.state.selectedTags,
      orders: this.state.orders.map( order => order.order_id),
      transport_type_id: transport_type,
      transport_class_id: this.state.mainOrder?.transport_class?.id || null,
      last_facility: this.props.transactionType === 1 ? this.state.mainOrder.to_facility.id : this.state.mainOrder.from_facility.id
    }

    this.props.callActionsOrder(data,  {
      onSuccess: (response) => {
        if (response.response_msg && response.response_msg.error && response.response_msg.error.length > 0) {

          this.setState({
            errorMessage: response.response_msg.error.join(', ')
          });

        } else if (response.notifications) {

          try {
            (response.notifications || []).map( item => {
              sendMessageToMultipleUsersInSocket(
                this.props.userId,
                item['users'],
                item['data']
              );
            });
          } catch(e) {
            console.log('error:', e)
          }

          showSimpleFlashNotification('Se realizó el cambio con éxito', null);
          this.props.handleChange({
            target: {
              name: 'load_items'
            }
          });
          this.onClose();

        } else {
          this.setState({
            errorMessage: 'Ocurrió un error, intente de nuevo'
          })
        }
      },
      onError: (e) => {
        this.setState({
          errorMessage: e.response?.data?.error || 'Ocurrió un error, intente de nuevo'
        })
      }
    })

  }

  isAbleToConvertToOrder = () => {

    return(
      this.state.orders.length > 0 &&
      this.state.selectedCode !== '' &&
      this.state.codeDuplicated === false
    );

  }

  buildActions = () => {
    return(
      <div className="actions">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          {
            this.state.isConsolidateOrders ?
            <div>{`Total de Órdenes Seleccionadas ${this.state.ordersToAdd.length}`}</div> :
            <div>{`Total de Órdenes ${this.state.orders.length}`}</div>
          }

          <div style={{display: 'flex'}}>

            <Button
              disabled={this.props.isLoading || this.props.isCreationLoading}
              text={'Cancelar'}
              type={'btn secondary primary'}
              onClick={() => {

                if (this.state.isConsolidateOrders) {
                  this.setState({
                    isConsolidateOrders: false,
                  });
                } else {
                  this.onClose();
                }

              }}
            />

            <div style={{width: 20}}/>

            <Button
              disabled={ this.state.isConsolidateOrders ? (this.props.isLoading || this.props.isCreationLoading || this.state.ordersToAdd.length === 0) : (this.props.isLoading || this.props.isCreationLoading || !this.isAbleToConvertToOrder())}
              text={(this.props.isLoading || this.props.isCreationLoading ) ? <Loader circleColor={'black'}/> : this.state.isConsolidateOrders ? 'Agregar' : 'Convertir en Embarque'}
              type={'btn outline primary dark'}
              onClick={() => {

                if (this.state.isConsolidateOrders) {

                  let orders_in_common = this.state.inboundOrders.concat(this.state.outboundOrders).filter((obj_1, i, arr) => 
                    arr.findIndex(obj_2 => (obj_2.order_id === obj_1.order_id)) === i
                  );
                  let new_orders = orders_in_common.filter( item => this.state.ordersToAdd.includes(item.order_id) );

                  this.setState({
                    orders: this.state.orders.concat(new_orders),
                    isConsolidateOrders: false
                  });

                } else {

                  this.props.validateCodeTrip({
                    company_id: this.props.companyId,
                    code: this.state.selectedCode
                  }, {
                    onSuccess: (response) => {

                      let is_found = 'exist' in response && response.exist;

                      if (is_found) {
                        this.setState({
                          codeDuplicated: true
                        });
                      } else {
                        this.convertOrdersToTrip();
                      }

                    }
                  });

                }

              }}
            />

          </div>

        </div>
      </div>
    );
  }

  buildConsolidateDeliveriesContentHeaders = () => {
    let current_orders = this.state.orders.map(item => item.order_id);

    return( 
      <div className="consolidate-deliveries-content">

        <div style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: 20,
          marginBottom: 10
        }}>
          <div 
            className={`option-tab ${this.state.optionSelected === 1 ? 'selected' : ''}`} style={{marginRight: 15}}
            onClick={() => {
              if (this.state.optionSelected !== 1) {
                this.setState({
                  optionSelected: 1
                });
              }
            }}
          >
            <div>{this.state.inboundOrders.filter( item => !current_orders.includes(item.order_id)).length}</div>
            <div>{'Órdenes Compra'}</div>
          </div>

          <div 
            className={`option-tab ${this.state.optionSelected === 2 ? 'selected' : ''}`}
            onClick={() => {
              if (this.state.optionSelected !== 2) {
                this.setState({
                  optionSelected: 2
                });
              }
            }}
          >
            <div>{this.state.outboundOrders.filter( item => !current_orders.includes(item.order_id)).length}</div>
            <div>{'Órdenes Venta'}</div>
          </div>
        </div>

        <div className="delivery-row">
          <div style={{width: 20}}/>
          <div className="delivery-item">{'Número de Orden'}</div>
          <div className="delivery-item">{'Origen'}</div>
          <div className="delivery-item">{'Destino'}</div>
          <div className="delivery-item">{'Cita de Carga'}</div>
          <div className="delivery-item">{'Cita de Descarga'}</div>
          <div className="delivery-item">{'Tipo'}</div>
          <div className="delivery-item">{'Mercancía Peligrosa'}</div>
          <div className="delivery-item">{'Clase de Expedición'}</div>
          <div className="delivery-item">{'Estatus de Orden'}</div>
        </div>
      </div>
    );
  }

  buildConsolidateOrdersContent = () => {

    let current_orders = this.state.orders.map(item => item.order_id);
    let orders_to_show = (this.state.optionSelected === 1 ? this.state.inboundOrders : this.state.outboundOrders).filter( item => !current_orders.includes(item.order_id));

    return(
      <div className="consolidate-deliveries-content">

        <div className="delivery-list">

          { 
            this.props.isOrdersInCommonLoading ? <Loader circleColor={'black'} /> : orders_to_show.length === 0 ? 
              <div
                style={{
                  height: '35%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'end',
                  fontSize: 18
                }}
              >{'No hay órdenes que coincidan'}</div> : 
            orders_to_show.map( (order, index) => {

              let type = '';
              let transport_class = '';

              if (order.type === 'FTL') {
                type = `${order.type} - ${(order.container_ids || []).length > 1 ? 'Full' : 'Sencillo'}`;
              } else {
                type = order.type;
              }

              if ((this.props.company?.type?.id || 0) === 3) {

                let from_facility_company_type = this.state.requisition?.from_facility?.company?.type_id || 0;
                let to_facility_company_type = this.state.requisition?.to_facility?.company?.type_id || 0;

                if (from_facility_company_type === 3 && this.state.optionSelected === 2) {
                  transport_class = order.transport_class_provider?.label || '';
                } else if (to_facility_company_type === 3 && this.state.optionSelected === 1) {
                  transport_class = order.transport_class_client?.label || '';
                }

              } else {

                if (this.props.companyId === (order.from_company?.id || 0)) {
                  transport_class = order.transport_class_provider?.label || '';
                } else {
                  transport_class = order.transport_class_client?.label || '';
                }

              }


              return(
                <div className="delivery-row with-hover" key={`delivery-row-${index}`}>
                  <div 
                    className={`checkbox-container ${this.state.ordersToAdd.includes(order.order_id) ? 'selected' : ''}`}
                    onClick={() => {
                      if (this.state.ordersToAdd.includes(order.order_id)) {
                        this.setState({
                          ordersToAdd: this.state.ordersToAdd.filter( item => item !== order.order_id)
                        })
                      } else {
                        this.state.ordersToAdd.push(order.order_id);
                        this.setState({});
                      }
                    }}
                  >
                    <div className="checkbox"></div>
                  </div>

                  <div className="delivery-item">{`${order.order_code}`}</div>
                  <div className="delivery-item">{this.getOrigin(order)}</div>
                  <div className="delivery-item">{this.getDestiny(order)}</div>
                  <div className="delivery-item">{this.getAppointmentLoadingDate(order)}</div>
                  <div className="delivery-item">{this.getAppointmentUnloadingDate(order)}</div>
                  <div className="delivery-item">{type}</div>
                  <div className="delivery-item">{`${order.has_dangerous_products ? 'Sí' : 'No'}`}</div> 
                  <div className="delivery-item">{transport_class}</div> 
                  <div className="delivery-item">{`${order.order_status?.description || ''}`}</div>
                  
                </div>
              );

            })
          }

        </div>
      
      </div>
    );
  }

  render() {
    return (
      <Modal
        isOpen={this.props.orders !== null}
        portalClassName={`dialog convert-orders-to-trip-dialog ${this.props.addClass ? this.props.addClass : ""}`}
        overlayClassName="overlay"
        className="content"
      >

        <div className="close" onClick={() => {
          this.onClose();
        }}></div>

        { this.buildTitle() }

        { this.state.isConsolidateOrders && this.buildConsolidateDeliveriesContentHeaders()}

        {
          this.state.isConsolidateOrders ?
          <div style={{overflow: 'hidden', overflowY: 'auto', height: 'calc(100% - 278px)'}}>
            { this.buildConsolidateOrdersContent() }
          </div> :
          <div style={{overflow: 'hidden', overflowY: 'auto', height: this.state.errorMessage !== null ? 'calc(100% - 143px)' : 'calc(100% - 130px)', paddingRight: 20}}>
            { this.buildOrderInputs() }
            { this.buildOrders() }
            { this.buildAddMoreOrders() }
          </div>

        }

        {
          this.state.errorMessage !== null &&
          <RecommendationError>
            {this.state.errorMessage}
          </RecommendationError>
        }

        { this.buildActions() }

      </Modal>
    );
  }

}

const mapStateToProps = (state) => {

  const companyId = state.globalCatalog.session.company.id;
  const ordersInCommon = getEntityItems(state, "COMPANIES.REQUISITIONSCONTROL.ORDERS.ORDERSINCOMMON"); 
  const isOrdersInCommonLoading = state?.api['COMPANIES.REQUISITIONSCONTROL.ORDERS.ORDERSINCOMMON']?.status?.isFetching || false;
  const isValidatingLoading = state?.api['COMPANIES.REQUISITIONSCONTROL.ORDERS.VALIDATECODE']?.status?.isFetching || false;
  const isCreationLoading = state?.api['COMPANIES.REQUISITIONSCONTROL.ORDERS.ACTIONS']?.status?.isFetching || false;

  return {
    companyId,
    ordersInCommon,
    isOrdersInCommonLoading,
    isCreationLoading: isValidatingLoading || isCreationLoading,
    company: state.globalCatalog.session.company
  };
}

const mapDispatchToProps = (dispatch) => {
  dispatch(loadSession());

  return {
    cancelMultipleRequests: () => dispatch(cancelMultipleRequests()),
    loadFacilityRequisitions: (params, opt) => dispatch(readEntities("COMPANIES.REQUISITIONSCONTROL.ORDERS.ORDERSINCOMMON", params, opt)),
    validateCodeTrip: (params, opt) => dispatch(readEntities("COMPANIES.REQUISITIONSCONTROL.TRIPS.VALIDATECODE", params, opt)),
    callActionsOrder: (params, opt) => dispatch(createEntity("COMPANIES.REQUISITIONSCONTROL.ORDERS.ACTIONS", params, opt)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConvertOrdersToTripModal);